import { createFileRoute } from "@tanstack/react-router";
import GhiduriHub from "@/pages/ghiduri/GhiduriHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghiduri/")({
  head: () => routeHead("/ghiduri/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <GhiduriHub />
  );
}
